import '@babel/polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import unhandledRejection from 'unhandled-rejection'

Vue.use(Vuex)

let rejectionEmitter = unhandledRejection({
  timeout: 20
})

rejectionEmitter.on('unhandledRejection', (error, promise) => {
  console.error(error)
})

if (!window.Promise) {
  window.Promise = Promise
}

export { Vue, Vuex }
